
function PropertySourcingController(){
	this.className			= "PropertySourcingController";
	this.view				= false; //"example";
	this.glob				= [
        "/property-sourcing**",
        "/property-sourcing?grid",
        "/property-search**",
        "/property-search?grid"
    ];
    this.viewData			= {};
    this.log                = false;
}
PropertySourcingController.inheritsFrom( PageController );
PropertySourcingController.prototype.swap = function(onComplete){

    if (this.log) console.log(`%c[PropertySourcingController]`, 'background:cyan', `on`);

    this.$body			 = $('body');
    this.baseController  = Aviator.get("baseController")
    this.topicController = Aviator.get("topicController");
    // this.configTopicImageSymbolAnimation();

    this.topicController.scrollToFees();

    this.imageController = this.baseController.getImageController();
    this.imageLoadedOrFailedDelegate =  (e) => {
        if(!e.image) return; //Early ones aren't ready with an image
        // this.animationControllers.forEach(a => a.refresh());
    };
    this.imageController.addListener("refresh",this.imageLoadedOrFailedDelegate);
    this.imageController.addListener("failed",this.imageLoadedOrFailedDelegate);


    // Testimonials on mobile
    this.testimonials = document.querySelector('.js-sa-testimonials');
    if(this.testimonials) {
        this.testimonialContent = this.testimonials.querySelectorAll('.js-testimonial-item');
        this.testimonialContentArray = Array.from(this.testimonialContent);

        this.showTestimonials(this.testimonialContentArray, 2);
        window.addEventListener('resize', () => {
            this.showTestimonials(this.testimonialContentArray, 2);
        });
    }



    Preloader2.add("/assets/images/backgrounds/parque-white.svg").then(() => {
        //Add a delay to all it to render
        setTimeout(() => onComplete(), 10);
    });

    this.setupAnimations();

    return false;
}
PropertySourcingController.prototype.on = function(onComplete){

    return true;
}
PropertySourcingController.prototype.off = function(onComplete){

    if(this.imageController){
        if(this.imageLoadedOrFailedDelegate) this.imageController.removeListener("refresh",this.imageLoadedOrFailedDelegate);
        if(this.imageLoadedOrFailedDelegate) this.imageController.removeListener("failed",this.imageLoadedOrFailedDelegate);
    }

    this.animationControllers?.forEach(ac => {
        ac.destroy();
    });
    this.animationControllers = [];

    return true;
}

PropertySourcingController.prototype.setupAnimations = function () {
    this.animationControllers = [];

    new AnimationController({
        containerSelector: '#our-service',
        triggerStart: 'top 50%',
        triggerEnd: 'top top',
        showMarkers: false,
        once: true,
        onScroll: false,
        items: [{
            selector: '#our-service .js-stat-item',
            start: { opacity: 0 },
            end: { opacity: 1 },
            options: {
                duration: 0.5,
                stagger: 0.25
            }
        }],
    });

    new AnimationController({
        containerSelector: '#our-process',
        triggerStart: 'top 50%',
        triggerEnd: 'top top',
        showMarkers: false,
        once: true,
        onScroll: false,
        items: [{
            selector: '#our-process .js-stat-item',
            start: { opacity: 0 },
            end: { opacity: 1 },
            options: {
                duration: 0.5,
                stagger: 0.25
            }
        }],
    });

    /*
    new AnimationController({
        containerSelector: '#testimonials',
        triggerStart: 'top 50%',
        triggerEnd: 'top top',
        showMarkers: false,
        once: true,
        onScroll: false,
        items: [{
            selector: '.js-testimonial-item',
            start: { opacity: 0 },
            end: { opacity: 1 },
            options: {
                duration: 0.5,
                stagger: 0.1
            }
        }],
    });
    */


    // We might need to swap top 30% for bottom 30%, so we see the bottom text animate.
    // Additionally, we might need two animation controller definitions below to separate the two types of animations.
    // We might be able to avoid this with a happy median... possibly.

    /*
    const fadeInAnimationSettings = {
        selector: '.js-symbol-letter',
        start: { opacity: 0 },
        end: { opacity: 1 },
        duration: 1,
        delay: 0,
        ease: 'power2.inOut',
    };

    this.animateSymbol("#topic-image-symbol-0", [fadeInAnimationSettings]);
    this.animateSymbol("#topic-image-symbol-1", [fadeInAnimationSettings]);
    this.animateSymbol("#topic-image-symbol-2", [fadeInAnimationSettings]);
    this.animateSymbol("#topic-image-symbol-3", [fadeInAnimationSettings]);

    this.animateSymbolLetters("#topic-image-symbol-0", [
        {
            start: { x: 0, y: -8 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0,
            ease: 'power2.out',
        },{
            start: { x: 0, y: -8 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0.1,
            ease: 'power2.out',
        },{
            start: { x: 0, y: -8 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0.2,
            ease: 'power2.out',
        },{
            start: { x: 0, y: -8 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0.3,
            ease: 'power2.out',
        },{
            start: { x: 0, y: -8 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0.4,
            ease: 'power2.out',
        },{
            start: { x: 0, y: -8 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0.5,
            ease: 'power2.out',
        }
    ]);

    this.animateSymbolLetters("#topic-image-symbol-1", [
        {
            start: { x: 0, y: -4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .07,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: 4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: -4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .08,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: 4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .05,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: -4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .025,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: 4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .1,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: -4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .1,
            ease: 'sine.inOut',
        }
    ]);

    this.animateSymbolLetters("#topic-image-symbol-2", [
        {
            start: { x: -6, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .3,
            ease: 'sine.inOut',
        },{
            start: { x: -4, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .2,
            ease: 'sine.inOut',
        },{
            start: { x: -2, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .1,
            ease: 'sine.inOut',
        },{
            start: { x: 2, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .1,
            ease: 'sine.inOut',
        },{
            start: { x: 4, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .2,
            ease: 'sine.inOut',
        },{
            start: { x: 6, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .3,
            ease: 'sine.inOut',
        },
    ]);

    this.animateSymbolLetters("#topic-image-symbol-3", [
        {
            start: { x: -4, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .07,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: 4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: 0,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: -4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .08,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: 4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .05,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: -4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .025,
            ease: 'sine.inOut',
        },{
            start: { x: 0, y: 4 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .1,
            ease: 'sine.inOut',
        },{
            start: { x: 4, y: 0 },
            end: { x: 0, y: 0 },
            duration: 1,
            delay: .1,
            ease: 'sine.inOut',
        }
    ]);
    */
}


PropertySourcingController.prototype.animateSymbol = function (element, items = []) {
    const elem = document.querySelector(element);

    const itemsToAnimate = [];

    items.forEach((item, index) => {
        itemsToAnimate.push({
            selector: `${element} ${item.selector}`,
            start: item.start,
            end: item.end,
            duration: parseFloat(item.duration),
            delay: parseFloat(item.delay),
            ease: item.ease,
        });
    })

    const animationController = new AnimationController({
        containerSelector: element,
        items: itemsToAnimate,
        triggerStart: 'top bottom',
        triggerEnd: 'top 50%', // bottom 30%
        showMarkers: false
    });
}
PropertySourcingController.prototype.animateSymbolLetters = function (element, items = []) {

    // console.log(element);

    const elem = document.querySelector(element);
    const letters = elem.querySelectorAll('.js-symbol-letter');
    // console.log(items);

    const lettersArrayToAnimate = [];
    if(letters.length) letters.forEach((letter, index) => {
        if (!items[index]) return;

        lettersArrayToAnimate.push({
            selector: `${element} .js-symbol-letter:nth-of-type(${index+1})`,
            start: {
                x: parseFloat(items[index].start.x),
                y: parseFloat(items[index].start.y)
            },
            end: {
                x: parseFloat(items[index].end.x),
                y: parseFloat(items[index].end.y)
            },
            duration: parseFloat(items[index].duration),
            delay: parseFloat(items[index].delay),
            ease: items[index].ease,
        });
    })

    if(!letters.length) {
        lettersArrayToAnimate.push({
            selector: `${element}`,
            start: items[0].start,
            end: items[0].end,
            duration: parseFloat(items[0].duration),
            delay: parseFloat(items[0].delay),
            ease: items[0].ease,
        });
    }

    // We might need to swap top 30% for bottom 30%, so we see the bottom text animate.
    // Additionally, we might need two animation controller definitions below to separate the two types of animations.
    // We might be able to avoid this with a happy median... possibly.

    const animationController = new AnimationController({
        containerSelector: element,
        items: lettersArrayToAnimate,
        triggerStart: 'top bottom',
        triggerEnd: '30% 50%', // bottom 30%
        showMarkers: false
    });


    // Stats animation
    // const statsAnimation = [
    //     {
    //         selector: '.js-symbol-stat-1',
    //         start: { opacity: 0, x: 0, y: 50 },
    //         end: { opacity: 1, x: 0, y: 0 },
    //         duration: 1,
    //         delay: 0,
    //         ease: 'sine.inOut',
    //     },{
    //         selector: '.js-symbol-stat-2',
    //         start: { opacity: 0, x: 0, y: 50 },
    //         end: { opacity: 1, x: 0, y: 0 },
    //         duration: 1,
    //         delay: 0,
    //         ease: 'sine.inOut',
    //     },{
    //         selector: '.js-symbol-stat-3',
    //         start: { opacity: 0, x: 0, y: 50 },
    //         end: { opacity: 1, x: 0, y: 0 },
    //         duration: 1,
    //         delay: 0,
    //         ease: 'sine.inOut',
    //     },
    // ];
    //
    //
    // const statsToAnimate = [];
    // statsAnimation.forEach((stat, index) => {
    //
    //     statsToAnimate.push({
    //         selector: stat.selector,
    //         start: {
    //             opacity: parseFloat(stat.start.opacity),
    //             x: parseFloat(stat.start.x),
    //             y: parseFloat(stat.start.y)
    //         },
    //         end: {
    //             opacity: parseFloat(stat.end.opacity),
    //             x: parseFloat(stat.end.x),
    //             y: parseFloat(stat.end.y)
    //         },
    //         duration: parseFloat(stat.duration),
    //         delay: parseFloat(stat.delay),
    //         ease: stat.ease,
    //     });
    // })
    //
    // statsAnimation.forEach((stat, index) => {
    //
    //     gsap.fromTo(
    //         stat.selector,
    //         {
    //             opacity: parseFloat(stat.start.opacity),
    //             x: parseFloat(stat.start.x),
    //             y: parseFloat(stat.start.y)
    //         },
    //         {
    //             opacity: parseFloat(stat.end.opacity),
    //             x: parseFloat(stat.end.x),
    //             y: parseFloat(stat.end.y),
    //             scrollTrigger: {
    //                 trigger:   '.stats-block',
    //                 start:    'top top',
    //                 end:      'bottom 50%',
    //                 showMarkers: true,
    //             }
    //         }
    //     )
    // });

    // const animationController2 = new AnimationController({
    //     containerSelector: element,
    //     items: statsToAnimate,
    //     triggerStart: 'top bottom',
    //     triggerEnd: 'bottom 50%',
    //     showMarkers: true
    // });

    this.animationControllers.push(animationController);
}


PropertySourcingController.prototype.configTopicImageSymbolAnimation = function () {

    if (this.log) console.log(`%c[PropertySourcingController]`, 'background:cyan', `configTopicImageSymbolAnimation`);

    this.animationControllers = [];

    const topicImageSymbolList = document.querySelectorAll('.topic-image-symbol');
    topicImageSymbolList.forEach((topicImageSymbol, index) => {
        const containerSelector = `#topic-image-symbol-${index}`;

        const startX = (index%2==0) ? 8 : -8;
        const topicSymbols = [
            {
                selector: `${containerSelector} .topic-symbol`,
                start: {
                    x: startX,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                },
                duration: 1,
            },
        ]


        var animationController = new AnimationController({
            containerSelector: containerSelector,
            items: topicSymbols,
            triggerStart: 'top bottom',
            triggerEnd: 'top 30%',
            showMarkers: false
        });

        this.animationControllers.push(animationController);
    })
};

PropertySourcingController.prototype.showTestimonials = function (testimonialArray, limit=null) {
    if (window.innerWidth < 1000) {
        // only show the first 3 testimonials
        testimonialArray.forEach((testimonial, index) => {
            if (index > limit) {
                testimonial.style.display = 'none';
            }
        });

    } else {
        testimonialArray.forEach((testimonial, index) => {
            testimonial.style.display = 'block';
        });
    }
};
